import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './MobileCoverageSummary-hashed.scss';
import templateStr from 'text!./mobile-coverage-summary.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            offering: '&',
            coverageType: '@',
            lobCode: '&'
        },
        template: cssUtil.hashTemplate(templateStr, styles),
        controller: ['$scope', function ($scope) {
            $scope.getCoverages = function () {
                return $scope.offering()[$scope.coverageType];
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/common/directives/CommonOfferingSelection/mobileQuoteView/mobile-coverage-summary/MobileCoverageSummary.js
// module id = 2126
// module chunks = 0